import { render, staticRenderFns } from "./Dashboard_old.vue?vue&type=template&id=1992fae6&scoped=true&"
import script from "./Dashboard_old.vue?vue&type=script&lang=js&"
export * from "./Dashboard_old.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_old.vue?vue&type=style&index=0&id=1992fae6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992fae6",
  null
  
)

export default component.exports